import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { guardedCustomElement } from '../utils/guarded-custom-element';
import { styles } from './sds-popover.styles';
import './assets/positioning.js';

type SDSPopoverPlacement = 'top' | 'bottom' | 'left' | 'right' | 'none';
type SDSPopoverAutoPlacement = 'true' | 'false';
type SDSPopoverOverscroll = 'contain';

export interface SDSPopoverProps {
	placement?: SDSPopoverPlacement;
	autoPlacement?: SDSPopoverAutoPlacement;
	overscroll?: SDSPopoverOverscroll;
}

@guardedCustomElement('sds-popover')
export class SDSPopover extends LitElement {
	static override styles = [styles];

	@property({ type: String, attribute: 'data-placement', reflect: true })
	placement: SDSPopoverProps['placement'] = 'top';

	@property({ type: String, attribute: 'data-autoplacement', reflect: true })
	autoPlacement: SDSPopoverProps['autoPlacement'] = undefined;

	@property({ type: String, attribute: 'data-overscroll', reflect: true })
	overscroll: SDSPopoverProps['overscroll'] = undefined;

	override connectedCallback(): void {
		super.connectedCallback();

		if (!this.hasAttribute('popover')) {
			this.setAttribute('popover', 'auto');
		}

	}

	override render() {
		return html`<slot></slot>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'sds-popover': SDSPopover;
	}
}
